import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Form, Input, Button, Divider } from 'antd';
import s from './s.module.less';
import { RecognitionItem } from 'types/newUniprofile';
import { isEqual } from 'lodash';

interface Props {
    initValue?: RecognitionItem[];
    isEditing?: boolean;
}

const ProfessionalMembers = forwardRef((props: Props, ref) => {
    const { isEditing, initValue } = props;
    const [form] = Form.useForm<{ awardsList: RecognitionItem[] }>();
    const prevInitValueRef = useRef<RecognitionItem[]>();

    useEffect(() => {
        // 只有当initValue内容真正发生变化时才更新表单
        if (initValue?.length && !isEqual(prevInitValueRef.current, initValue)) {
            form.setFieldsValue({
                awardsList: initValue,
            });
            prevInitValueRef.current = initValue;
        }
    }, [initValue]);

    const getValues = async () => {
        const values = await form.validateFields();
        return values.awardsList;
    };

    useImperativeHandle(ref, () => ({
        getValues,
    }));

    const renderEditing = () => {
        return (
            <Form
                form={form}
                autoComplete="off"
                layout="vertical"
                scrollToFirstError
            >
                <Form.List name="awardsList">
                    {
                        (fields, { add, remove }) => {
                            return (
                                <div className={s.wrap}>
                                    <div className={s.label}>Professional memberships or associations</div>
                                    <Divider style={{ margin: '4px 0px 12px' }} />
                                    {
                                        fields.map(({ key, name, ...restField }, index) => {
                                            return (
                                                <div key={key} className={s.card}>
                                                    <div
                                                        id={`Association_${index + 1}`}
                                                    />
                                                    <Form.Item
                                                        {...restField}
                                                        label={`Association ${index + 1}`}
                                                        name={[name, 'name']}
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                    <div className={s.formFooter}>
                                                        <Button onClick={() => remove(index)}>Remove</Button>
                                                    </div>
                                                </div>

                                            );
                                        })
                                    }
                                    <div
                                        onClick={() => add()}
                                        className={s.add}
                                    >
                                        + Add another association
                                    </div>
                                </div>
                            );
                        }
                    }
                </Form.List>
            </Form>

        );
    };

    const renderReview = () => {
        if (!initValue?.length) {
            return (
                <div className="mb-6">
                    <div className={s.label}>Professional memberships or associations</div>
                    <div className="mt-2">
                        Not provided
                    </div>
                </div>
            );
        }
        return (
            <div className="mb-6">
                <div className={s.label}>Professional memberships or associations</div>
                <ul className="list-disc ml-4 mt-2">
                    {initValue?.map((item, index) => {
                        return (
                            <li key={index}>{item.name}</li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    return (
        <div>
            {isEditing ? renderEditing() : renderReview()}
        </div>
    );
});

export default ProfessionalMembers;
